import {apiClient} from "../../providers/apiClient";
import Utilities from "../../utils/Utilities";

const downloadCsvReport = async (filters) => {
    try {
        const response = await apiClient.get('/api/Account/csv', {
            params: filters,
            responseType: 'blob',
        });

        const url = window.URL.createObjectURL(new Blob([response.data]));
        const link = document.createElement('a');
        
        const name = filters?.isConsumer ? "consumers" : "users";
        
        const fileName = `${name}-report_${Utilities.formatDateForFilename()}.csv`;

        link.href = url;
        link.setAttribute('download', fileName);
        document.body.appendChild(link);
        link.click();

        link.remove();
        window.URL.revokeObjectURL(url);
    } catch (error) {
        console.error('Błąd przy pobieraniu pliku CSV:', error);
    }
}


export default {
    downloadCsvReport
}